/* ============================================================
   SMARTCUBES — produktsider: bevægelse og finish (v2)
   - Prisen hopper let, når den ændrer sig
   - Indtoning ved scroll med forskudt rækkefølge
   - Leveringsboksen får en tidslinje: Bestil -> Afsendes -> Hos dig
   - Størrelsesguiden tegnes op, og målene tæller op
   - Læg i kurv bekræftes med flueben; Duo-bakker flyver ned i baren
   - Tryghedsikoner tegnes op, anmeldelsestal og portionsguide tæller
   Ændrer ikke købslogikken; den ligger i smartcubes-pdp.js og
   smartcubes-duo.js. Leveringsdatoerne beregnes i smartcubes-cart.js.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function bump(el) {
    if (!el) return;
    el.classList.remove('scm-bump');
    void el.offsetWidth;
    el.classList.add('scm-bump');
  }

  function watchText(el) {
    if (!el || !('MutationObserver' in window)) return;
    var last = el.textContent;
    new MutationObserver(function () {
      if (el.textContent !== last) { last = el.textContent; bump(el); }
    }).observe(el, { childList: true, characterData: true, subtree: true });
  }

  /* Kør fn én gang, når el er tydeligt i syne */
  function onSeen(el, fn, threshold) {
    if (!hasIO) { fn(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.disconnect(); fn(); }
      });
    }, { threshold: threshold || 0.35 });
    io.observe(el);
  }

  /* ---------- Leveringsdatoer (samme regler som smartcubes-cart.js) ---------- */
  var DAYS = ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'];
  var MONTHS = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];
  var CUTOFF_HOUR = 20;

  function utc(y, m, d) { return new Date(Date.UTC(y, m, d)); }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function dkey(d) { return d.getUTCFullYear() + '-' + d.getUTCMonth() + '-' + d.getUTCDate(); }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
        mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return utc(y, mo - 1, da);
  }
  var holidayCache = {};
  function holidays(y) {
    var out = {}, e = easter(y);
    function add(d) { out[dkey(d)] = true; }
    add(utc(y, 0, 1)); add(addDays(e, -3)); add(addDays(e, -2)); add(addDays(e, 1));
    if (y < 2024) add(addDays(e, 26));
    add(addDays(e, 39)); add(addDays(e, 50));
    add(utc(y, 11, 24)); add(utc(y, 11, 25)); add(utc(y, 11, 26)); add(utc(y, 11, 31));
    return out;
  }
  function closed(d) {
    var w = d.getUTCDay();
    if (w === 0 || w === 6) return true;
    var y = d.getUTCFullYear();
    if (!holidayCache[y]) holidayCache[y] = holidays(y);
    return !!holidayCache[y][dkey(d)];
  }
  function nextBusinessDay(d) { d = addDays(d, 1); while (closed(d)) d = addDays(d, 1); return d; }
  function addBusinessDays(d, n) { while (n > 0) { d = addDays(d, 1); if (!closed(d)) n--; } return d; }
  function danishNow() {
    try {
      var v = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Copenhagen', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (p) { if (p.type !== 'literal') v[p.type] = parseInt(p.value, 10); });
      return { date: utc(v.year, v.month - 1, v.day), hour: v.hour };
    } catch (e) {
      var n = new Date();
      return { date: utc(n.getFullYear(), n.getMonth(), n.getDate()), hour: n.getHours() };
    }
  }
  function parseKey(s) {
    var p = (s || '').split('-');
    return p.length === 3 ? utc(+p[0], +p[1], +p[2]) : null;
  }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function dayLabel(d) { return cap(DAYS[d.getUTCDay()]) + ' ' + d.getUTCDate() + '. ' + MONTHS[d.getUTCMonth()]; }
  function rangeLabel(a, b) {
    if (dkey(a) === dkey(b)) return a.getUTCDate() + '. ' + MONTHS[a.getUTCMonth()];
    if (a.getUTCMonth() === b.getUTCMonth()) return a.getUTCDate() + '.–' + b.getUTCDate() + '. ' + MONTHS[b.getUTCMonth()];
    return a.getUTCDate() + '. ' + MONTHS[a.getUTCMonth()] + '–' + b.getUTCDate() + '. ' + MONTHS[b.getUTCMonth()];
  }

  /* Ikoner til leveringsforløbet: kurv -> pakke -> lastbil. Kun <path>, så de kan tegnes op */
  var ICON_ATTR = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
  var ICONS = [
    '<svg class="sc-eta__ic" ' + ICON_ATTR + '><path pathLength="1" d="M3 4.5h2.3l2.2 10h10.2L19.8 8H6.4"/><path pathLength="1" d="M8.4 19a1.3 1.3 0 1 0 2.6 0a1.3 1.3 0 1 0 -2.6 0"/><path pathLength="1" d="M15 19a1.3 1.3 0 1 0 2.6 0a1.3 1.3 0 1 0 -2.6 0"/></svg>',
    '<svg class="sc-eta__ic" ' + ICON_ATTR + '><path pathLength="1" d="M12 3.2l7.8 4.3v9L12 20.8l-7.8-4.3v-9z"/><path pathLength="1" d="M4.2 7.5L12 11.8l7.8-4.3"/><path pathLength="1" d="M12 11.8v9"/><path pathLength="1" d="M8.1 5.35l7.8 4.3"/></svg>',
    '<svg class="sc-eta__ic" ' + ICON_ATTR + '><path pathLength="1" d="M2.5 6.5h11v9h-11z"/><path pathLength="1" d="M13.5 9.5h4l3 3.2v2.8h-7"/><path pathLength="1" d="M5.4 17.6a1.6 1.6 0 1 0 3.2 0a1.6 1.6 0 1 0 -3.2 0"/><path pathLength="1" d="M15.4 17.6a1.6 1.6 0 1 0 3.2 0a1.6 1.6 0 1 0 -3.2 0"/></svg>'
  ];

  function setupEta(eta) {
    if (!eta || eta.hasAttribute('data-preorder') || eta.getAttribute('data-scm-eta') === '1') return;
    eta.setAttribute('data-scm-eta', '1');
    var track = null;

    function fill() {
      var parts = (eta.getAttribute('data-eta-key') || '').split('|');
      var from = parseKey(parts[0]), to = parseKey(parts[1]);
      if (!from || !to) return;

      var now = danishNow();
      var ship = nextBusinessDay(now.date);
      if (now.hour >= CUTOFF_HOUR) ship = nextBusinessDay(ship);
      var ok = false;
      for (var n = 1; n <= 6 && !ok; n++) { if (dkey(addBusinessDays(ship, n)) === dkey(from)) ok = true; }
      var shipText = ok ? dayLabel(ship) : 'Næste hverdag';

      if (!track) {
        track = document.createElement('div');
        track.className = 'sc-eta__track';
        track.innerHTML =
          '<div class="sc-eta__steps">' +
            '<span class="sc-eta__fill" aria-hidden="true"></span>' +
            '<span class="sc-eta__mover" aria-hidden="true">' + ICONS.join('') + '</span>' +
            '<ol class="sc-eta__list" aria-label="Leveringsforløb">' +
              '<li><i aria-hidden="true"></i><b>Bestil</b><span>I dag</span></li>' +
              '<li><i aria-hidden="true"></i><b>Afsendes</b><span data-scm-ship></span></li>' +
              '<li><i aria-hidden="true"></i><b>Hos dig</b><span data-scm-arrive></span></li>' +
            '</ol>' +
          '</div>';
        eta.appendChild(track);
        var steps = track.firstChild;
        var lis = steps.querySelectorAll('li');
        var ics = steps.querySelectorAll('.sc-eta__ic');
        var timers = [], playing = false;
        function stage(i) {
          each(ics, function (ic, k) { ic.classList.toggle('is-on', k === i); ic.classList.toggle('is-past', i > -1 && k < i); });
        }
        function at(ms, fn) { timers.push(setTimeout(fn, ms)); }
        function setPos(v) { steps.style.setProperty('--p', v); steps.style.setProperty('--x', v); }
        /* Nulstil uden overgange, så forløbet kan spilles igen */
        function reset() {
          timers.forEach(clearTimeout); timers = [];
          playing = false;
          steps.classList.add('is-reset');
          steps.classList.remove('is-play', 'is-done');
          setPos(0); stage(-1);
          each(lis, function (li) { li.classList.remove('is-on'); });
          void steps.offsetWidth;
          steps.classList.remove('is-reset');
        }
        function play() {
          if (playing) return;
          playing = true;
          if (reduce) {
            steps.classList.add('is-play', 'is-done');
            setPos(1); stage(2);
            each(lis, function (li) { li.classList.add('is-on'); });
            return;
          }
          /* Bestil: kurven tegnes op ved første punkt */
          steps.classList.add('is-play');
          stage(0);
          lis[0].classList.add('is-on');
          /* Afsendes: kurven bliver til en pakke på vej mod midten */
          at(900, function () { setPos(0.5); });
          at(1180, function () { stage(1); });
          at(1800, function () { lis[1].classList.add('is-on'); });
          /* Hos dig: pakken bliver til en lastbil på vej mod sidste punkt */
          at(2350, function () { setPos(1); });
          at(2630, function () { stage(2); });
          at(3250, function () { lis[2].classList.add('is-on'); steps.classList.add('is-done'); });
        }
        /* Spilles hver gang boksen kommer i syne; nulstilles, når den er helt ude af syne */
        if (!hasIO || reduce) {
          play();
        } else {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.intersectionRatio >= 0.6) play();
              else if (!en.isIntersecting && playing) reset();
            });
          }, { threshold: [0, 0.6] }).observe(eta);
        }
      }
      track.querySelector('[data-scm-ship]').textContent = shipText;
      track.querySelector('[data-scm-arrive]').textContent = rangeLabel(from, to);
    }

    fill();
    if ('MutationObserver' in window) {
      new MutationObserver(fill).observe(eta, { attributes: true, attributeFilter: ['data-eta-key'] });
    }
  }

  /* ---------- Størrelsesguiden ---------- */
  function num(txt) {
    var m = String(txt || '').match(/(\d+(?:[.,]\d+)?)/);
    return m ? parseFloat(m[1].replace(',', '.')) : null;
  }
  /* Tæller et tal op (eller ned) til den tekst, elementet har nu */
  function countUp(dd, fromVal, durMs) {
    var final = dd.textContent;
    var m = final.match(/^(\s*)(\d+(?:[.,]\d+)?)(.*)$/);
    if (!m || reduce) return;
    var target = parseFloat(m[2].replace(',', '.'));
    var start = typeof fromVal === 'number' && !isNaN(fromVal) ? fromVal : 0;
    if (start === target) return;
    var dec = (m[2].split(/[.,]/)[1] || '').length;
    var comma = m[2].indexOf(',') !== -1;
    var t0 = null, dur = durMs || 1000;
    function fmt(v) { var s = v.toFixed(dec); return comma ? s.replace('.', ',') : s; }
    function step(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - k, 3);
      dd.textContent = m[1] + fmt(start + (target - start) * e) + m[3];
      if (k < 1) requestAnimationFrame(step); else dd.textContent = final;
    }
    dd.textContent = m[1] + fmt(start) + m[3];
    requestAnimationFrame(step);
  }

  function restart(el, cls) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  }

  /* Tegner alle streger i et ikon op (sættes i gang med en klasse) */
  function prepDraw(svg) {
    each(svg.querySelectorAll('path, circle, rect, line, polyline, polygon, ellipse'), function (el) {
      var len = 0;
      try { len = el.getTotalLength(); } catch (e) { len = 0; }
      len = Math.ceil(len || 60) + 2;
      el.style.strokeDasharray = len;
      el.style.strokeDashoffset = len;
    });
  }

  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path pathLength="1" d="M5 12.5l4.2 4.2L19 7"/></svg>';

  /* ---------- Læg i kurv: knappen bekræfter med et flueben ---------- */
  function setupAdded(root) {
    var btns = [];
    each(root.querySelectorAll('[data-scp-add], .scd-bar__cta'), function (b) {
      if (!b.querySelector('.scx-ok')) b.insertAdjacentHTML('beforeend', '<span class="scx-ok" aria-hidden="true">' + CHECK + '<span>Lagt i kurv</span></span>');
      btns.push(b);
    });
    if (!btns.length) return;
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
          if (!ev || ev.source !== 'product-form') return;
          btns.forEach(function (b) {
            b.classList.add('is-added');
            clearTimeout(b._scxT);
            b._scxT = setTimeout(function () { b.classList.remove('is-added'); }, 1900);
          });
        });
      }
    } catch (e) {}
  }

  /* ---------- Tryghedspunkterne: ikonerne tegnes op ---------- */
  function setupStrip(root) {
    var strip = root.querySelector('.scp-strip');
    if (!strip || reduce || !hasIO || strip.classList.contains('scx-prep')) return;
    var svgs = strip.querySelectorAll('svg');
    if (!svgs.length) return;
    each(svgs, function (svg, i) { prepDraw(svg); svg.style.setProperty('--d', (0.1 + i * 0.18) + 's'); });
    strip.classList.add('scx-prep');
    onSeen(strip, function () { requestAnimationFrame(function () { strip.classList.add('scx-go'); }); }, 0.5);
  }

  /* ---------- Anmeldelser: 4,8 tæller op ---------- */
  function setupScore(root) {
    var b = root.querySelector('.scp-rv__score b');
    if (!b || reduce || !hasIO) return;
    var box = b.closest('.scp-rv__score');
    var finalText = b.textContent;
    var vh = window.innerHeight || 800;
    if (box.getBoundingClientRect().top > vh) b.textContent = finalText.replace(/\d+([.,]\d+)?/, function (x) { return x.replace(/\d/g, '0'); });
    onSeen(box, function () { b.textContent = finalText; countUp(b, 0, 1100); }, 0.5);
  }

  /* ---------- Find din portion: billede, tekst og tal skifter blødt ---------- */
  function setupFinder(root) {
    var tabs = root.querySelector('.scp-cfg-tabs');
    var cfg = root.querySelector('.scp-cfg');
    if (!tabs || !cfg || reduce) return;
    var photo = cfg.querySelector('[data-scp-cfg-photo]');
    var body = cfg.querySelector('.scp-cfg-body');
    var nums = [cfg.querySelector('[data-cfg-rooms]'), cfg.querySelector('[data-cfg-vol]'), cfg.querySelector('[data-cfg-total]')];
    var before = [];
    tabs.addEventListener('click', function (e) {
      if (!e.target.closest('.scp-cfg-tab')) return;
      before = nums.map(function (n) { return n ? num(n.textContent) : null; });
    }, true);
    tabs.addEventListener('click', function (e) {
      if (!e.target.closest('.scp-cfg-tab')) return;
      restart(body, 'scx-swap');
      if (photo && photo.getAttribute('src')) {
        var go = function () { restart(photo, 'scx-swap'); };
        if (photo.complete) go(); else photo.addEventListener('load', go, { once: true });
      }
      nums.forEach(function (n, i) { if (n) countUp(n, before[i], 650); });
    });
  }

  /* ---------- Duo: bakken flyver ned i "Din Duo" ---------- */
  function setupDuo(root) {
    var scd = root.querySelector('[data-scd]');
    var bar = root.querySelector('[data-scd-bar]');
    if (!scd || !bar) return;
    var slots = bar.querySelector('[data-scd-bar-slots]');
    var title = bar.querySelector('.scd-bar__title');
    if (title && !title.querySelector('.scx-check')) title.insertAdjacentHTML('beforeend', CHECK.replace('<svg ', '<svg class="scx-check" '));
    if (reduce || !slots || !Element.prototype.animate) return;

    scd.addEventListener('click', function (e) {
      var plus = e.target.closest('[data-scd-plus]');
      if (!plus || plus.disabled) return;
      var card = plus.closest('[data-scd-card]');
      var img = card && card.querySelector('[data-scd-card-img]');
      if (!img || !img.getAttribute('src')) return;
      var from = img.getBoundingClientRect();
      var count = slots.querySelectorAll('.scd-slot.is-filled').length;
      requestAnimationFrame(function () { fly(img, from, count); });
    }, true);

    function barOffset() {
      var t = getComputedStyle(bar).transform;
      if (!t || t === 'none') return 0;
      var m = t.match(/matrix\(([^)]+)\)/);
      return m ? parseFloat(m[1].split(',')[5]) || 0 : 0;
    }

    function fly(img, from, count) {
      var filled = slots.querySelectorAll('.scd-slot.is-filled');
      if (filled.length <= count) return;
      var target, to, toTop, inBar = bar.classList.contains('is-on');
      if (inBar) {
        /* Baren er fremme: bakken lander i sin plads */
        target = filled[filled.length - 1];
        to = target.getBoundingClientRect();
        toTop = to.top - barOffset();
      } else {
        /* Baren er skjult: bakken lander i "Din Duo"-linjen over knappen */
        target = root.querySelector('[data-scd-summary]');
        if (!target) return;
        var r = target.getBoundingClientRect();
        if (r.bottom < 0 || r.top > (window.innerHeight || 800)) return;
        to = { left: r.left + 10, top: r.top + r.height / 2 - 20, width: 40, height: 40 };
        toTop = to.top;
      }
      var ghost = img.cloneNode(false);
      ghost.removeAttribute('data-scd-card-img');
      ghost.className = 'scx-ghost';
      ghost.style.cssText = 'position:fixed;z-index:60;pointer-events:none;margin:0;object-fit:contain;border-radius:10px;' +
        'left:' + from.left + 'px;top:' + from.top + 'px;width:' + from.width + 'px;height:' + from.height + 'px;';
      document.body.appendChild(ghost);
      var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
      var dy = (toTop + to.height / 2) - (from.top + from.height / 2);
      var sc = Math.max(0.15, to.width / from.width);
      if (inBar) target.style.opacity = '0';
      var anim = ghost.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.55 - 40) + 'px) scale(' + (1 + sc) / 2 + ')', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sc + ')', opacity: inBar ? 0.6 : 0 }
      ], { duration: 650, easing: 'cubic-bezier(.45,0,.25,1)' });
      anim.onfinish = function () {
        ghost.remove();
        if (inBar) {
          target.style.opacity = '';
          if (target.animate) target.animate([{ transform: 'scale(.8)' }, { transform: 'scale(1.08)' }, { transform: 'none' }], { duration: 360, easing: 'cubic-bezier(.22,1,.36,1)' });
        } else if (target.animate) {
          target.animate([{ transform: 'none' }, { transform: 'scale(1.025)' }, { transform: 'none' }], { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
      };
    }
  }

  function setupDims(box) {
    if (!box || reduce || !hasIO || box.classList.contains('scm-prep')) return;
    var svg = box.querySelector('svg');
    if (!svg) return;

    each(svg.querySelectorAll('rect'), function (r, i) {
      var len = 0;
      try { len = r.getTotalLength(); } catch (e) { len = 0; }
      if (!len) {
        var w = parseFloat(r.getAttribute('width')) || 0, h = parseFloat(r.getAttribute('height')) || 0;
        len = 2 * (w + h);
      }
      len = Math.ceil(len) + 2;
      r.classList.add('scm-draw');
      r.style.strokeDasharray = len;
      r.style.strokeDashoffset = len;
      r.style.setProperty('--d', (i === 0 ? 0 : i === 4 ? 0.35 : 0.2 + i * 0.12) + 's');
    });

    var dimDelay = 0.75, tickDelay = 1.1;
    each(svg.querySelectorAll('path'), function (p) {
      var d = (p.getAttribute('d') || '').trim();
      if (/^M[\d.\s,]+[vV][\d.\-]+$/.test(d)) {
        p.classList.add('scm-gy'); p.style.setProperty('--d', dimDelay + 's'); dimDelay += 0.18;
      } else if (/^M[\d.\s,]+[hH][\d.\-]+$/.test(d)) {
        p.classList.add('scm-gx'); p.style.setProperty('--d', dimDelay + 's'); dimDelay += 0.18;
      } else {
        p.classList.add('scm-tick'); p.style.setProperty('--d', tickDelay + 's'); tickDelay += 0.18;
      }
    });
    each(svg.querySelectorAll('.lb'), function (t, i) { t.style.setProperty('--d', (1.25 + i * 0.16) + 's'); });

    var rows = box.querySelectorAll('.scp-dims__rows > div');
    each(rows, function (row, i) {
      var base = 0.3 + i * 0.16;
      row.style.setProperty('--d', base + 's');
      var dt = row.querySelector('dt'), dd = row.querySelector('dd');
      if (dt) dt.style.setProperty('--d', base + 's');
      if (dd) dd.style.setProperty('--d', (base + 0.08) + 's');
    });
    var note = box.querySelector('.scp-dims__note');
    if (note) note.style.setProperty('--d', (0.4 + rows.length * 0.16 + 0.2) + 's');

    box.classList.add('scm-prep');
    onSeen(box, function () {
      requestAnimationFrame(function () {
        box.classList.add('scm-go');
        each(rows, function (row, i) {
          var dd = row.querySelector('dd');
          if (dd) setTimeout(function () { countUp(dd); }, (0.38 + i * 0.16) * 1000);
        });
      });
    }, 0.4);
  }

  /* Grupper, der tones ind én ad gangen, når de kommer i syne */
  var GROUPS = [
    '.scp-strip > div',
    '.scp-panels > details',
    '.scp-faq > details',
    '.scp-rv__grid > .scp-rv__card',
    '.scp-cfg-tabs > button'
  ];
  var SINGLES = [
    '.sc-eta',
    '.scp-rv__score',
    '.scp-rv__feat',
    '.scp-cfg',
    '.scp-po-code, .sc-po-code'
  ];

  function init(root) {
    if (root.getAttribute('data-scm') === '1') return;
    root.setAttribute('data-scm', '1');

    /* ---------- Prisen hopper let, når den ændrer sig ---------- */
    if (!reduce) {
      watchText(root.querySelector('[data-scp-price]'));
      watchText(root.querySelector('[data-scd-bar-price]'));
      watchText(root.querySelector('[data-scp-add-price]'));
      watchText(root.querySelector('[data-scp-s-price]'));
    }

    /* ---------- Leveringsboks og størrelsesguide ---------- */
    setupEta(root.querySelector('.sc-eta'));
    setupDims(root.querySelector('.scp-dims'));

    /* ---------- Kurv-feedback, ikoner, anmeldelser, portionsguide, Duo ---------- */
    setupAdded(root);
    setupStrip(root);
    setupScore(root);
    setupFinder(root);
    setupDuo(root);

    /* ---------- Indtoning ved scroll ---------- */
    if (reduce || !hasIO) return;
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('scm-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    function arm(el, delay) {
      if (!el || el.classList.contains('scm-r')) return;
      /* Kun ting under folden — det, kunden allerede ser, røres ikke */
      if (el.getBoundingClientRect().top < vh * 0.92) return;
      if (delay) el.style.setProperty('--scm-d', delay + 's');
      el.classList.add('scm-r');
      io.observe(el);
    }

    GROUPS.forEach(function (sel) {
      var items = root.querySelectorAll(sel);
      each(items, function (el, i) { arm(el, Math.min(i, 6) * 0.07); });
    });
    SINGLES.forEach(function (sel) {
      each(root.querySelectorAll(sel), function (el) { arm(el, 0); });
    });
  }

  function boot() {
    each(document.querySelectorAll('[data-scp]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
